import { render } from "./EmptyTable.vue?vue&type=template&id=16657b22&scoped=true"
const script = {}

import "./EmptyTable.vue?vue&type=style&index=0&id=16657b22&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16657b22"]])

export default __exports__